<ui-card padding="md">
  <section
    class="wishlist-detail-access-state"
    data-testid="wishlist-detail-access-state"
  >
    <ui-empty-state
      [title]="state().title"
      [description]="state().description"
      [iconLabel]="state().iconLabel"
      [tone]="state().tone"
    />
  </section>
</ui-card>
